module.exports = __webpack_public_path__ + "img/08—02—Diagnostic information.d494cd1c.jpg";